import {createSelector} from 'reselect';
import {getStartDate} from '../../App/selectors';

export const selectStartDate = createSelector([getStartDate], startDate => startDate);
